import React from 'react'
import PropTypes from 'prop-types'

const TextWithLineBreaks = ({ text }) => {
    const lines = text.split(/\r\n|\n/).filter(line => line.trim() !== '');

    return (
        <div>
            {lines.map((line, index) => (
                <p key={index}>{line}</p>
            ))}
        </div>
    );
}

TextWithLineBreaks.propTypes = {
    text: PropTypes.string.isRequired,
}

export default TextWithLineBreaks